import { getChromeNotifications } from '../chrome/wrappers';

/**
 * Show a visual notification in the system tray.
 *
 * @param id - Identifier of the notification. If it matches an existing notification, it will clear it before showing again.
 * @param title - Title of the notification.
 * @param message - Main notification content.
 */
export const display = (id: string, title: string, message: string) => {
  getChromeNotifications().create(id, {
    type: 'basic',
    iconUrl: 'images/qustodio-128x128.png',
    title,
    message,
  });
};
